import React from "react";
import { Star } from "lucide-react";

export default function ReviewsShowcase({ reviews }) {
  if (!reviews || reviews.enabled === false) return null;
  const items = (reviews.items || []).filter((r) => r.text).slice(0, 6);
  const rating = Number(reviews.rating);
  if (!rating && !items.length) return null;
  return (
    <div className="mt-8" data-testid="reviews-showcase">
      {rating > 0 && (
        <p className="font-display font-black uppercase text-2xl text-[#0C0C0C] flex items-center gap-2" data-testid="reviews-rating">
          <Star size={22} fill="#0C0C0C" /> {rating.toFixed(1).replace(".", ",")} SU GOOGLE
          {reviews.count ? <span className="font-bold text-base text-[#0C0C0C]/70">· {reviews.count} recensioni</span> : null}
        </p>
      )}
      {items.length > 0 && (
        <div className="mt-4 flex gap-4 overflow-x-auto no-scrollbar snap-x-mandatory pb-2">
          {items.map((r, i) => (
            <figure key={i} className="snap-start shrink-0 w-[260px] rounded-2xl border-2 border-[#0C0C0C] p-4" data-testid={`review-card-${i}`}>
              <div className="flex gap-0.5" aria-label={`${r.stars || 5} stelle`}>
                {Array.from({ length: Number(r.stars) || 5 }).map((_, k) => <Star key={k} size={14} fill="#0C0C0C" />)}
              </div>
              <blockquote className="mt-2 text-sm font-semibold text-[#0C0C0C] leading-snug">“{r.text}”</blockquote>
              {r.author && <figcaption className="mt-2 font-display font-bold uppercase text-sm text-[#0C0C0C]/70">— {r.author}</figcaption>}
            </figure>
          ))}
        </div>
      )}
    </div>
  );
}
